import React from 'react';
import styled from 'styled-components';
import HorizontalTabs from 'sushiweb/HorizontalTabs';

const tabStyles = `
  hr {
    background-color: #318616 !important;
    height: 4px;
    border-radius: 4px 4px 0px 0px !important;
    margin: 0;
  }
  h2 {
    border: none !important;
  }
`;

const TabsSectionWrapper = styled.div`
  > section {
    min-height: 0 !important;
    margin-top: 5px;
  }
`;

const IvaTabBar = ({ tabs, activeKey, onChange }) => (
  <div className='tw-flex tw-items-center tw-border-solid !tw-border-x-0 !tw-border-t-0 tw-border-base-green tw-border-2 tw-p-0 tw-m-0'>
    <TabsSectionWrapper>
      <HorizontalTabs alignLinks='left'>
        {tabs.map((tab) => (
          <HorizontalTabs.Link
            key={tab.key}
            id={tab.key}
            style={{
              cursor: 'pointer',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '200px',
            }}
            active={activeKey === tab.key}
            onClick={() => onChange(tab.key)}
            css={tabStyles}
          >
            <div
              className={`tw-font-medium ${
                activeKey === tab.key
                  ? 'tw-text-base-green tw-text-[1.4rem]'
                  : ''
              }`}
            >
              {tab.title}
            </div>
          </HorizontalTabs.Link>
        ))}
      </HorizontalTabs>
    </TabsSectionWrapper>
  </div>
);

export default IvaTabBar;
